import { CardProps } from '@material-ui/core'
import { PersonOutline } from '@material-ui/icons'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import { CardActionProps } from '../../../../../../../components/shared/cardActions/cardActions'
import { StandardCard } from '../../../../../../../components/shared/standardCard/standardCard'

interface ConsumptionCardProps extends CardProps {
  isLoading: boolean
  onAssociateConsumptionClick?: () => void
  footerActions?: CardActionProps[]
}

export const ConsumptionCard: React.FC<ConsumptionCardProps> = ({
  isLoading,
  footerActions,
  onAssociateConsumptionClick,
  ...props
}) => {
  const [t] = useTranslation(['globalerisLibrary', 'leads', 'enums'])
  const history = useHistory()

  const noData = true

  // #region Handlers Starts
  // #endregion Handlers Ends

  // #region Functions Starts
  // #endregion Functions Ends

  // #region Form Definition Starts
  // #endregion Form Definition Ends

  // #region DataTable Config Starts
  // #endregion DataTable Config Ends

  // #region Hooks Starts
  // #endregion Hooks Ends

  return (
    <StandardCard
      avatarIcon={<PersonOutline />}
      title={t('leads:components.leadFile.consumptionCard.title')}
      isLoading={isLoading}
      footerActions={footerActions}
      showEmptyContent={noData}
      emptyButtonCallback={onAssociateConsumptionClick}
      emptyButtonCaption={t('leads:components.leadFile.consumptionCard.emptyButtonCaption')}
      emptyCaption={t('leads:components.leadFile.consumptionCard.emptyCaption')}
      {...props}
    ></StandardCard>
  )
}
